/** Account settings — profile, security, workspace, and menu. */
export const moduleConfig = {
  module: {
    title: 'Account settings',
    description: 'Profile, security, workspace, and menu preferences',
    route: {
      list: '/account-settings',
      path: '/account-settings',
    },
  },
};

export default moduleConfig;
